import React from 'react';
import { Link } from 'react-router-dom';
import type { SolutionCommercialCta } from './types';

export const SolutionCommercialCtaBanner: React.FC<{
  cta: SolutionCommercialCta;
}> = ({ cta }) => (
  <section className="cl-cta-banner" aria-label="Partner call to action">
    <div className="cl-cta-banner__inner">
      <div className="cl-cta-banner__art" aria-hidden>
        <img
          className="cl-cta-banner__bg"
          src={cta.imageSrc}
          alt=""
          loading="lazy"
        />
      </div>

      <div className="cl-cta-banner__body">
        <h2 className="cl-cta-banner__title">{cta.title}</h2>
        <div className="cl-cta-banner__actions">
          <Link className="cl-cta-banner__btn cl-cta-banner__btn--primary" to={cta.primaryCta.to}>
            {cta.primaryCta.label}
          </Link>
          <Link className="cl-cta-banner__btn cl-cta-banner__btn--secondary" to={cta.secondaryCta.to}>
            {cta.secondaryCta.label}
          </Link>
        </div>
      </div>
    </div>
  </section>
);
